export default "__VITE_ASSET__DsxbqVEu__"